<template>
  <div class="tile-content">
    <div :class="['img', 'img-' + img ]"></div>
    <div class="text" v-html="text"></div>
  </div>
</template>

<script>
// @ is an alias to /src
// import Idle from "@/views/Idle.vue";

export default {
  name: "intro_tile",
  props: { text: String, img: Number },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
.tile-content {
  width: 100%;
  height: 100%;
  // position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  font-family: "VW Head";
  font-weight: 300;
}
.img {
  width: 100%;
  height: 80px;
  background-image: url("~@/assets/img/wheel_icon.svg?external");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.img-0 {
  background-image: url("~@/assets/img/wheel_icon.svg?external");
}

.img-1 {
  background-image: url("~@/assets/img/part_icon.svg?external");
}

.img-2 {
  background-image: url("~@/assets/img/checkmark_icon.svg?external");
}
.img-3 {
  background-image: url("~@/assets/img/wheel.svg?external");
}
.text {
  margin-top: 5%;
  // height: 50%;
  // padding-left: 10%;
  // padding-right: 10%;
  width: 80%;
}
</style>

<style lang="scss" scoped>
@media (max-width: 1300px) {
}
</style>